import { starRatingWidgetParser } from "@redotech/redo-model/review/star-rating-widget-schema";
import * as z from "zod/v4";

export const getStarRatingWidgetByTeam = {
  name: "getStarRatingWidgetByTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.union([starRatingWidgetParser, z.null()]),
};
